import { Typography } from "@mui/material";
import PageLayout from "components/PageLayout";
import { formatError } from "utilities/formatError";

type ErrorPageProps = { error?: unknown };

type ErrorPageSubcomponents = {
  Forbidden: React.FC;
  NotFound: React.FC;
};

const ErrorPage: React.FC<ErrorPageProps> & ErrorPageSubcomponents = (props) => {
  const { error } = props;

  const { status, message } = formatError(error);

  return (
    <PageLayout sx={{ pt: 10, textAlign: "center" }}>
      <Typography variant="h1" fontWeight="bold" color="error.dark">
        {status}
      </Typography>

      <Typography variant="body1">{message}</Typography>
    </PageLayout>
  );
};

ErrorPage.Forbidden = () => <ErrorPage error={{ status: 403, message: "Åtkomst nekad" }} />;
ErrorPage.NotFound = () => <ErrorPage error={{ status: 404, message: "Sidan hittades inte" }} />;

export default ErrorPage;
